export const heroData = {
  title: "Customer Reviews",
  subtitle: "Here are testimonials from guests who have experienced Yokohama Helicopter Cruise through AIRDOA.",
  image:
    "https://readdy.ai/api/search-image?query=Smiling%20couple%20looking%20out%20of%20helicopter%20window%20at%20city%20night%20view%2C%20warm%20interior%20lighting%2C%20happy%20luxury%20travel%20experience%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=reviewhero01&orientation=landscape",
};

export const reviews = [
  {
    name: "K.Y.",
    age: "30s",
    scene: "Wedding Anniversary",
    rating: 5,
    date: "2025.04",
    comment:
      "We used AIRDOA for our wedding anniversary. The moment we saw Minato Mirai from the sky, we were speechless with emotion. The pilot was wonderful and we felt completely at ease. It became a memory we will treasure for the rest of our lives. The entire service was polished and luxurious.",
    image:
      "https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20Yokohama%20Minato%20Mirai%20district%20seen%20from%20inside%20helicopter%20cabin%2C%20romantic%20atmosphere%2C%20sparkling%20city%20lights%2C%20deep%20navy%20sky%2C%20no%20text&width=400&height=300&seq=rv01&orientation=landscape",
  },
  {
    name: "S.M.",
    age: "20s",
    scene: "Date",
    rating: 5,
    date: "2025.03",
    comment:
      "It was my first time in a helicopter, but the staff guided us so carefully that I had no anxiety at all. When the Bay Bridge came into view right in front of us, I got goosebumps. My girlfriend was overjoyed — it was the best date ever.",
    image:
      "https://readdy.ai/api/search-image?query=Illuminated%20Yokohama%20Bay%20Bridge%20aerial%20view%20at%20night%20from%20helicopter%2C%20deep%20navy%20sky%2C%20sparkling%20lights%2C%20romantic%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv02&orientation=landscape",
  },
  {
    name: "A.T.",
    age: "40s",
    scene: "Birthday Surprise",
    rating: 5,
    date: "2025.03",
    comment:
      "I used this as a birthday surprise for my wife. We chose the sunset course, and the transition from the setting sun to the night skyline was absolutely stunning. My wife was thoroughly thrilled. The staff were excellent and we would love to come back.",
    image:
      "https://readdy.ai/api/search-image?query=Sunset%20transitioning%20to%20night%20aerial%20view%20over%20Yokohama%20bay%2C%20warm%20orange%20and%20deep%20navy%20gradient%20sky%2C%20helicopter%20tour%20experience%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv03&orientation=landscape",
  },
  {
    name: "H.O.",
    age: "30s",
    scene: "Proposal",
    rating: 5,
    date: "2025.02",
    comment:
      "I asked the staff to help with a proposal. They helped me prepare the ring in front of the night view — every detail was taken care of. My partner was moved to tears and it became the most wonderful memory of my life. Thank you so much.",
    image:
      "https://readdy.ai/api/search-image?query=Night%20aerial%20view%20of%20Yokohama%20harbor%20with%20sparkling%20city%20lights%20from%20helicopter%2C%20romantic%20proposal%20moment%20concept%2C%20deep%20navy%20sky%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv04&orientation=landscape",
  },
  {
    name: "N.F.",
    age: "20s",
    scene: "Sightseeing",
    rating: 4,
    date: "2025.02",
    comment:
      "I enjoyed a helicopter tour as the finale to my Yokohama sightseeing trip. Seeing places I had walked around from above was incredibly moving. Next time I want to try the night view course.",
    image:
      "https://readdy.ai/api/search-image?query=Aerial%20daytime%20view%20of%20Yokohama%20port%20and%20city%20buildings%20from%20helicopter%2C%20bright%20sunny%20sky%2C%20travel%20sightseeing%20experience%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv05&orientation=landscape",
  },
  {
    name: "M.W.",
    age: "50s",
    scene: "Gift",
    rating: 5,
    date: "2025.01",
    comment:
      "I purchased a gift ticket for my husband. The packaging was beautiful and he was absolutely delighted. The experience on the day was wonderful too — we were both deeply moved. It was the perfect choice for a gift to someone special.",
    image:
      "https://readdy.ai/api/search-image?query=Luxury%20helicopter%20cabin%20interior%20with%20panoramic%20window%20showing%20night%20city%20skyline%2C%20warm%20golden%20lighting%20inside%2C%20romantic%20gift%20experience%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv06&orientation=landscape",
  },
];
